import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { WinCardSeventhVariantConfig } from '@shared/models';
import { RewardPipe, SafePipe, TransformUrlToBgPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-variant7',
  styleUrl: './variant7.component.scss',
  templateUrl: './variant7.component.html',
  imports: [SafePipe, RewardPipe, TransformUrlToBgPipe],
})
export class Variant7Component extends BaseComponent {
  amount = input<number>(0);
  config = input.required<WinCardSeventhVariantConfig>();
}
